import React, {useEffect} from 'react';
import {Container, Row, Col} from 'reactstrap';
import img from "../../assets/images/demos/men.jpg";
import {useTranslation} from "react-i18next";

const Content = () => {
    const {t} = useTranslation();

    const toTop = () => {
        document.body.scrollTop = 0;
        document.documentElement.scrollTop = 0;
    };

    useEffect(() => {
        toTop();
    }, []);

    return (
        <React.Fragment>
            <section className="section bg-light" id="wallet">
                <Container>
                    <Row className="justify-content-center pt-5">
                        <Col lg={5}>
                            <div className="text-center mb-5">
                                <img src={img} alt="" className="img-fluid rounded-1"/>
                            </div>
                        </Col>
                        <Col lg={7} className="ps-1">
                            <div className="text-start mb-5" style={{textIndent: "1.5rem"}}>
                                {t('about_us_content').split('\n\n').map(item => (<p>{item}</p>))}
                            </div>
                        </Col>
                    </Row>
                </Container>
            </section>
        </React.Fragment>
    );
}

export default Content;